import { Button, Popup } from 'semantic-ui-react';
import { FC } from 'react';


export const SyncButton: FC<{ load(...args: any): any, color: any }> = ({ load, color }) => (
    <Popup content = 'Sync' trigger={
        <Button
            circular
            color={color}
            onClick={load}
            icon='sync'
            size='medium'
            style={{ marginRight: '15px' }}
        />}
    />
);

export const FilterButton: FC<{ load(...args: any): any, color: any }> = ({ load, color }) => (
    <Popup content = 'SQL Filters' trigger={
        <Button
            circular
            color={color}
            onClick={load}
            icon='database'
            size='medium'
            style={{ marginRight: '15px' }}
        />}
    />
);

export const InjectionButton: FC<{ load(...args: any): any, color: any }> = ({ load, color }) => (
    <Popup content = 'Create test event' trigger={
        <Button
            circular
            color={color}
            onClick={load}
            icon='add'
            size='medium'
            style={{ marginRight: '15px' }}
        />}
    />
);

export const DeleteEventsButton: FC<{ load(...args: any): any, color: any }> = ({ load, color }) => (
    <Popup content = 'Delete Events' trigger={
        <Button
            circular
            color={color}
            onClick={load}
            icon='recycle'
            size='medium'
            style={{ marginRight: '15px' }}
        />}
    />
);

export const DownloadArchiveButton: FC<{ load(...args: any): any, color: any, disabled: boolean }> = ({ load, color, disabled }) => (
    <Popup content = 'Export all input files from this page' trigger={
        <Button
            circular
            color={color}
            onClick={load}
            icon='arrow down'
            size='medium'
            style={{ marginRight: '15px' }}
            disabled={disabled}
        />}
    />
);

export const DownloadEventsButton: FC<{ load(...args: any): any, color: any }> = ({ load, color }) => (
    <Popup content = 'Export all filtered events (5000 max)' trigger={
        <Button
            circular
            color={color}
            onClick={load}
            icon='cloud download'
            size='medium'
            style={{ marginRight: '15px' }}
        />}
    />
);
